import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=4a63899e&scoped=true&"
import script from "./Tiers.vue?vue&type=script&lang=ts&"
export * from "./Tiers.vue?vue&type=script&lang=ts&"
import style0 from "./Tiers.vue?vue&type=style&index=0&id=4a63899e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63899e",
  null
  
)

export default component.exports